/**
 * Effects module loader
 * Lazily loads all effect files when initEffects() is called
 */
import { clearEffects } from '../utils/actions.js';

/**
 * Initialize the effects system by loading all effect modules
 * Effects handle I/O operations (Firestore, APIs, etc.)
 * Should NOT be initialized in demo mode to prevent side effects
 * @returns {Promise<Object>} Object containing all loaded effect modules
 */
export async function initEffects() {
  // Lazy import all effect files (exclude test files, setup files, and index)
  const effectModules = import.meta.glob(['./**/*.js', '!./**/*.test.js', '!./index.js', '!./test-setup.js']);
  
  // Load all modules
  const loadedModules = await Promise.all(
    Object.entries(effectModules).map(async ([path, importFn]) => {
      const module = await importFn();
      return [path, module];
    })
  );
  
  // Collect all effect exports (for potential debugging/inspection)
  const effects = {};
  
  loadedModules.forEach(([path, module]) => {
    // Store module exports for inspection
    const fileName = path.replace('./', '').replace('.js', '');
    effects[fileName] = module;
  });
  
  console.log('Effects initialized');
  return effects;
}

// Hot reload handling - clear and reregister effects
if (import.meta.hot) {
  import.meta.hot.accept(async () => {
    console.log('Effects hot-reloading...');
    clearEffects();
    await initEffects();
    console.log('Effects re-registered after hot reload');
  });
}